import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../security/AuthContext';
import { executeForgotPasswordService } from '../api/AuthenticationApiService';
import './ForgotPasswordComponent.css';

// Make sure the component name matches the file name (PascalCase)
function ForgotPasswordComponent() {
    const [email, setEmail] = useState('');
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [requestCompleted, setRequestCompleted] = useState(false);
    
    const navigate = useNavigate();
    const authContext = useAuth();

    function handleEmailChange(event) {
        setEmail(event.target.value);
    }

    async function handleResetRequest() {
        // Clear auth data
        authContext.logout();
        
        try {
            const response = await executeForgotPasswordService(email);
            
            if (response.data && response.data.passwordLookupResult !== 'error') {
                setShowErrorMessage(false);
                setRequestCompleted(true);
            } else {
                setShowErrorMessage(true);
                setRequestCompleted(false);
            }
        } catch (error) {
            console.error('Password reset request failed:', error);
            setShowErrorMessage(true);
            setRequestCompleted(false);
        }
    }

    return (
        <div className="forgot-password-main-content">
            <div className="forgot-password-container">
                <div className="forgot-password-box">
                    <h2 className="forgot-password-title">Forgot password?</h2>

                    <div className="form-field">
                        <input
                            type="text"
                            placeholder="Email"
                            className="form-input"
                            value={email}
                            onChange={handleEmailChange}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') handleResetRequest();
                            }}
                        />
                    </div>

                    <button
                        className="auth-button reset-button"
                        onClick={handleResetRequest}
                    >
                        <span className="heart-icon">♥</span> Submit
                    </button>

                    {showErrorMessage &&
                        <div className="error-message">Request error</div>
                    }
                    
                    {requestCompleted &&
                        <div className="success-message">Request completed</div>
                    }

                    <div className="instructions">
                        <p>If you forgot your password, please enter your email address. If there is a valid account we will send the results.</p>
                    </div>

                    <div className="action-links">
                        <Link to="/login" className="back-link">Back to Login</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

// Make sure the export name matches the component name
export default ForgotPasswordComponent;